(() => {
  // Defining once supports multiple sections and theme-editor re-rendering.
  if (customElements.get('c-gift-lp-share')) return;

  class GiftLPShare extends HTMLElement {
    connectedCallback() {
      if (this.copyButton) return;
      this.copyButton = this.querySelector('[data-gift-copy]');
      this.urlField = this.querySelector('[data-gift-url]');
      this.manualField = this.querySelector('[data-gift-manual]');
      this.status = this.querySelector('[data-gift-status]');
      if (!this.copyButton || !this.urlField || !this.manualField || !this.status) return;
      this.onCopy = () => this.copy();
      this.copyButton.addEventListener('click', this.onCopy);
      // Server-rendered links work without JavaScript; keep the copy payload identical.
      const configuredUrl = this.dataset.url;
      if (!configuredUrl) return;
      let url;
      try {
        url = new URL(configuredUrl);
        if (url.protocol !== 'https:') return;
      } catch (_) {
        return;
      }
      const message = (this.dataset.message || '').trim();
      this.urlField.value = url.href;
      this.manualField.value = [message, url.href].filter(Boolean).join('\n');
      const body = encodeURIComponent(this.manualField.value);
      const subject = encodeURIComponent(this.dataset.subject || '');
      const destinations = {
        line: `https://line.me/R/share?text=${body}`,
        whatsapp: `https://wa.me/?text=${body}`,
        email: `mailto:?subject=${subject}&body=${body}`
      };
      this.querySelectorAll('[data-gift-channel]').forEach(link => {
        link.href = destinations[link.dataset.giftChannel];
      });
      this.copyButton.disabled = false;
    }

    disconnectedCallback() {
      this.copyButton?.removeEventListener('click', this.onCopy);
      clearTimeout(this.statusTimer);
      clearTimeout(this.statusClearTimer);
      this.statusTimer = null;
      this.statusClearTimer = null;
      this.copyButton = null;
    }

    showStatus(message) {
      if (!message) return;
      clearTimeout(this.statusTimer);
      clearTimeout(this.statusClearTimer);
      this.status.textContent = message;
      this.status.dataset.visible = 'true';
      this.statusTimer = setTimeout(() => {
        if (this.isConnected) {
          this.status.dataset.visible = 'false';
          this.statusClearTimer = setTimeout(() => {
            if (this.isConnected && this.status.dataset.visible === 'false') this.status.textContent = '';
            this.statusClearTimer = null;
          }, 250);
        }
        this.statusTimer = null;
      }, 4000);
    }

    async copy() {
      const button = this.copyButton;
      const field = this.manualField;
      const status = this.status;
      if (!button || button.disabled) return;
      clearTimeout(this.statusTimer);
      clearTimeout(this.statusClearTimer);
      status.dataset.visible = 'false';
      status.textContent = '';
      button.disabled = true;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(field.value);
        if (this.isConnected) this.showStatus(this.dataset.success);
      } catch (_) {
        if (this.isConnected) {
          this.showStatus(this.dataset.error);
          field.hidden = false;
          field.focus();
          field.select();
          field.setSelectionRange(0, field.value.length);
        }
      } finally {
        if (this.isConnected) button.disabled = false;
      }
    }
  }

  customElements.define('c-gift-lp-share', GiftLPShare);
})();
